import React from 'react';

import type { SvgProps } from '../enums';

export const FlagGY: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55060"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55060)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V12H0V0Z"
        fill="#5EAA22"
      />
      <path
        d="M0.5 11.2933V0.706699L15.4977 6L0.5 11.2933Z"
        fill="#FECA00"
        stroke="#F7FCFF"
      />
      <path
        d="M-0.5 11.9777V0.0223197L7.18559 6L-0.5 11.9777Z"
        fill="#E11C1B"
        stroke="#272727"
      />
    </g>
  </svg>
);
